import { gql } from '@apollo/client';

const CREATE_ORDER_CORRECTION = gql`
  mutation CreateOrderCorrection($orderNodeId: ID!) {
    createOrderCorrection(orderNodeId: $orderNodeId) {
      order {
        id
      }
    }
  }
`;

export default CREATE_ORDER_CORRECTION;
